import React from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'antd';
import { ExperimentOutlined } from '@ant-design/icons';
import SubMenuIndexes from 'modules/layoutModule/enums/SubMenuIndexes';
import MenuIndexes from 'modules/layoutModule/enums/MenuIndexes';
import {
  gtwModulesList,
  GtwSubModuleDefinition,
  NewsSubModuleDefinition,
} from 'enums/modulesDefinition';

const { SubMenu } = Menu;

export const GtwMenuTab = (
  subMenuClick: any,
  setSelectedMenu: any,
  subModulesData: any,
  title: string,
  userModules: any[]
) => {
  const renderSubModules = (el: any) => {
    switch (el.id) {
      case GtwSubModuleDefinition.gtwArtAdd:
        return (
          <Menu.Item
            key={MenuIndexes.GTW_ARTICLES_ADD}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/gtw-art/add">{el.title}</Link>
          </Menu.Item>
        );
      case GtwSubModuleDefinition.gtwArt:
        return (
          <Menu.Item
            key={MenuIndexes.GTW_ARTICLES}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/gtw-art">{el.title}</Link>
          </Menu.Item>
        );
      case GtwSubModuleDefinition.gtwRequirementsAdd:
        return (
          <Menu.Item
            key={MenuIndexes.GTW_REQUIREMENTS_ADD}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/gtw-requirements/add">{el.title}</Link>
          </Menu.Item>
        );
      case GtwSubModuleDefinition.gtwRequirements:
        return (
          <Menu.Item
            key={MenuIndexes.GTW_REQUIREMENTS}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/gtw-requirements">{el.title}</Link>
          </Menu.Item>
        );
      case GtwSubModuleDefinition.gtwFilesAdd:
        return (
          <Menu.Item
            key={MenuIndexes.GTW_FILES_ADD}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/gtw-files/add">{el.title}</Link>
          </Menu.Item>
        );
      case GtwSubModuleDefinition.gtwFiles:
        return (
          <Menu.Item
            key={MenuIndexes.GTW_FILES}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/gtw-files">{el.title}</Link>
          </Menu.Item>
        );
      case GtwSubModuleDefinition.gtwEditionsAdd:
        return (
          <Menu.Item
            key={MenuIndexes.GTW_EDITIONS_ADD}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/gtw-editions/add">{el.title}</Link>
          </Menu.Item>
        );
      case GtwSubModuleDefinition.gtwEditions:
        return (
          <Menu.Item
            key={MenuIndexes.GTW_EDITIONS}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/gtw-editions">{el.title}</Link>
          </Menu.Item>
        );
      default:
        return null;
    }
  };

  const checkPermissions = gtwModulesList.filter((module) => {
    if (userModules.includes(module.id)) return module;
  });

  if (checkPermissions.length === 0) {
    return <></>;
  }

  return (
    <SubMenu
      key={SubMenuIndexes.GTW}
      icon={<ExperimentOutlined />}
      title={title}
      onTitleClick={(e) => subMenuClick(e)}
    >
      {checkPermissions.map((module) => renderSubModules(module))}
    </SubMenu>
  );
};
